//i18n.js:
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import al from './locales/al.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import gr from './locales/gr.json';
import it from './locales/it.json';
import ma from './locales/ma.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';
import ro from './locales/ro.json';


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true, // Helpful for seeing logs in your console
        detection: {
            // Which options does the detector use to find out language?
            // We say: 1) check localStorage, 2) fallback to the browser language
            order: ['localStorage', 'navigator'],
            // Where to store the user’s selected language:
            caches: ['localStorage'],
        },
        resources: {
            al: { translation: al },
            de: { translation: de },
            en: { translation: en },
            es: { translation: es },
            pt: { translation: pt },
            fr: { translation: fr },
            gr: { translation: gr },
            it: { translation: it },
            ma: { translation: ma },
            pl: { translation: pl },
            ro: { translation: ro },
        },
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
    });

export default i18n;
